export enum WorkspaceSettingsPage {
  AI = 'ai',
  APPS = 'apps',
  BILLING = 'billing',
  GENERAL = 'general',
  SAML = 'saml',
  SECURITY = 'security',
  SELF_HOSTED_GITLAB = 'self-hosted-gitlab',
  INFRASTRUCTURE = 'infrastructure',
  TEAM = 'team',
}
